// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  /* Inherit --brand-* from :root (BrandThemeService). Soft/hover helpers. */
  --brand-accent-hover: color-mix(in srgb, var(--brand-accent, #2563eb) 85%, black);
  --brand-accent-soft: color-mix(in srgb, var(--brand-accent, #2563eb) 10%, white);
  --brand-button-hover: color-mix(in srgb, var(--brand-button, #2563eb) 85%, black);
  --brand-button-soft: color-mix(in srgb, var(--brand-button, #2563eb) 10%, white);
}

.slick-header {
  height: 70px;
  background: #ffffff;
  box-shadow: 0 1px 0 #e7eaef, 0 2px 12px rgba(0, 0, 0, 0.04);
  color: #1a1a1a;
  position: relative;
}

.menu-btn {
  color: #1a1a1a;
  margin-right: 8px;
}

.mobile-menu {
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
}

.logo-link {
  display: flex;
  align-items: center;
  text-decoration: none;
  color: #1a1a1a;
  margin-right: 24px;
  transition: all 0.3s ease;
}
.logo-link:hover {
  transform: scale(1.03);
}
.logo-link .logo-mark {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border-radius: 10px;
  background: var(--brand-icon, var(--brand-accent, #2563eb));
  color: #fff;
  font-family: var(--brand-font-family, "Source Sans Pro", "Helvetica Neue", Arial, sans-serif);
  font-weight: 800;
  font-size: 20px;
  line-height: 1;
  margin-right: 12px;
  overflow: hidden;
}
.logo-link .logo-mark.logo-mark-image {
  background: transparent;
  padding: 0;
}
.logo-link .logo-mark.logo-mark-image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}
.logo-link .brand {
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 1px;
  color: #1a1a1a;
  font-family: var(--brand-font-family, "Source Sans Pro", "Helvetica Neue", Arial, sans-serif);
}

.search-row {
  max-width: 680px;
  margin: 0 24px;
  min-width: 0;
}

.categories-trigger {
  flex-shrink: 0;
}

.categories-btn {
  height: 44px;
  border-radius: 22px;
  border-color: #e2e6ec;
  color: #374151;
  font-weight: 500;
  letter-spacing: 0.3px;
  padding: 0 16px;
  background: #f8fafc;
  transition: all 0.25s ease;
}
.categories-btn mat-icon {
  margin-right: 6px;
  color: var(--brand-accent);
}
.categories-btn:hover, .categories-trigger:hover .categories-btn {
  border-color: var(--brand-accent);
  background: var(--brand-accent-soft);
  color: var(--brand-accent);
}

.search-container {
  max-width: none;
  margin: 0;
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  align-items: center;
  background: #f1f4f8;
  border-radius: 30px;
  padding: 10px 20px;
  border: 1px solid #e2e6ec;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.search-container:hover, .search-container:focus-within {
  background: #fff;
  border-color: var(--brand-accent);
  box-shadow: 0 4px 20px color-mix(in srgb, var(--brand-accent) 15%, transparent);
}
.search-container mat-icon:first-child {
  color: #8a94a3;
  margin-right: 16px;
  font-size: 20px;
  transition: color 0.3s ease;
}
.search-container ::ng-deep .search-input {
  flex: 1;
  background: transparent;
  border: none;
  outline: none;
  color: #1a1a1a;
  font-size: 15px;
  font-weight: 400;
  letter-spacing: 0.3px;
}
.search-container ::ng-deep .search-input::placeholder {
  color: #98a2b3;
  font-weight: 400;
}
.search-container button {
  color: #6b7280;
  margin-left: 12px;
  transition: all 0.3s ease;
}
.search-container button:hover {
  background: var(--brand-accent-soft);
  color: var(--brand-accent);
  transform: scale(1.1);
}
.search-container:focus-within mat-icon:first-child {
  color: var(--brand-accent);
}
.search-container .clear-btn {
  margin-left: 4px !important;
  margin-right: 4px !important;
}
.search-container .clear-btn mat-icon {
  font-size: 18px !important;
}
.search-container ::ng-deep .completer-dropdown,
.search-container ::ng-deep .completer-dropdown-menu,
.search-container ::ng-deep .dropdown-menu {
  width: 100vw !important;
  height: 150px !important;
  max-height: 150px !important;
  overflow-y: auto !important;
  background: white !important;
  border: 1px solid #ddd !important;
  border-radius: 0 !important;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15) !important;
  margin-left: calc(-50vw + 50%) !important;
  z-index: 9999 !important;
  display: block !important;
}
.search-container ::ng-deep .completer-item,
.search-container ::ng-deep .completer-row,
.search-container ::ng-deep .dropdown-item {
  padding: 12px 20px !important;
  border-bottom: 1px solid #f0f0f0 !important;
  min-height: 40px !important;
  height: 40px !important;
  display: block !important;
  line-height: 40px !important;
  color: #333 !important;
  cursor: pointer !important;
  white-space: nowrap !important;
}
.search-container ::ng-deep .completer-item:hover,
.search-container ::ng-deep .completer-row:hover,
.search-container ::ng-deep .dropdown-item:hover {
  background: #f8f8f8 !important;
}

.nav-actions {
  z-index: 2;
  margin-left: auto;
}
.nav-actions .sell-btn {
  background: var(--brand-button, var(--brand-accent, #2563eb));
  color: #fff;
  font-weight: 500;
  font-family: "Helvetica Neue", Arial, sans-serif;
  letter-spacing: 0.5px;
  border-radius: 20px;
  padding: 0 20px;
  box-shadow: 0 4px 15px color-mix(in srgb, var(--brand-button, var(--brand-accent, #2563eb)) 30%, transparent);
  transition: all 0.3s ease;
}
.nav-actions .sell-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px color-mix(in srgb, var(--brand-button, var(--brand-accent, #2563eb)) 40%, transparent);
  background: var(--brand-button-hover, var(--brand-accent-hover));
}
.nav-actions .sell-btn mat-icon {
  margin-right: 8px;
}
.nav-actions button[mat-icon-button] {
  color: #4a4a4a;
  margin: 0 4px;
  transition: all 0.3s ease;
}
.nav-actions button[mat-icon-button]:hover {
  background: var(--brand-accent-soft);
  color: var(--brand-accent);
  transform: scale(1.1);
}
.nav-actions .user-btn {
  display: flex;
  align-items: center;
  padding: 8px 16px;
  border-radius: 20px;
  background: #f1f4f8;
  color: #1a1a1a;
  transition: all 0.3s ease;
  gap: 8px;
}
.nav-actions .user-btn:hover {
  background: #e7ecf3;
  transform: translateY(-1px);
}
.nav-actions .user-btn span {
  font-weight: 300;
  letter-spacing: 0.5px;
  text-transform: capitalize;
}
.nav-actions .user-btn mat-icon:last-child {
  transition: transform 0.3s ease;
}
.nav-actions .user-btn[aria-expanded=true] mat-icon:last-child {
  transform: rotate(180deg);
}

::ng-deep .mat-menu-panel {
  margin-top: 8px;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
}
::ng-deep .mat-menu-panel .user-info {
  display: flex;
  align-items: center;
  padding: 16px;
  background: var(--brand-accent);
  color: white;
  margin: -8px -8px 8px -8px;
  border-radius: 12px 12px 0 0;
  gap: 12px;
}
::ng-deep .mat-menu-panel .user-info mat-icon {
  font-size: 40px;
}
::ng-deep .mat-menu-panel .user-info .name {
  font-weight: 600;
  font-size: 16px;
}
::ng-deep .mat-menu-panel .user-info .email {
  font-size: 12px;
  opacity: 0.8;
}
::ng-deep .mat-menu-panel button[mat-menu-item] {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  transition: all 0.3s ease;
  gap: 12px;
}
::ng-deep .mat-menu-panel button[mat-menu-item]:hover {
  background: var(--brand-accent-soft);
}
::ng-deep .mat-menu-panel button[mat-menu-item] mat-icon {
  color: var(--brand-accent);
}

.breadcrumb-bar {
  background: #f8fafc;
  border-bottom: 1px solid #e7eaef;
  padding: 4px 0;
}
.breadcrumb-bar .container {
  max-width: none;
  width: 100%;
  margin: 0;
  padding: 0 16px;
  display: flex;
  align-items: center;
  gap: 2px;
}
.breadcrumb-bar button[mat-icon-button] {
  color: #6b7280;
  transition: all 0.25s ease;
}
.breadcrumb-bar button[mat-icon-button]:hover {
  color: var(--brand-accent);
  background: var(--brand-accent-soft);
}
.breadcrumb-bar xng-breadcrumb,
.breadcrumb-bar .add-listing-breadcrumb-root {
  display: inline-flex;
  align-items: center;
  flex: 1;
  min-width: 0;
  margin-left: 6px;
  padding-left: 12px;
  border-left: 1px solid #e2e6ec;
}
.breadcrumb-bar .rightbar {
  margin-left: auto;
  text-align: right;
}
.breadcrumb-bar .rightbar button {
  margin-left: auto;
}
.breadcrumb-bar xng-breadcrumb,
.breadcrumb-bar .add-listing-breadcrumb-root {
  font-size: 13px;
  font-family: "Helvetica Neue", Arial, sans-serif;
  font-weight: 400;
  letter-spacing: 0.4px;
  color: #6b7280;
}
.breadcrumb-bar ::ng-deep xng-breadcrumb .xng-breadcrumb-list,
.breadcrumb-bar .add-listing-breadcrumb-root .xng-breadcrumb-list {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin: 0;
  padding: 0;
  list-style: none;
}
.breadcrumb-bar ::ng-deep xng-breadcrumb .xng-breadcrumb-item,
.breadcrumb-bar .add-listing-breadcrumb-root .xng-breadcrumb-item {
  list-style: none;
}
.breadcrumb-bar ::ng-deep xng-breadcrumb .xng-breadcrumb-link,
.breadcrumb-bar ::ng-deep xng-breadcrumb .xng-breadcrumb-trail,
.breadcrumb-bar .add-listing-breadcrumb-root .xng-breadcrumb-link,
.breadcrumb-bar .add-listing-breadcrumb-root .xng-breadcrumb-trail {
  display: flex;
  align-items: center;
  white-space: nowrap;
}
.breadcrumb-bar ::ng-deep xng-breadcrumb .xng-breadcrumb-link,
.breadcrumb-bar .add-listing-breadcrumb-root .xng-breadcrumb-link {
  color: #666;
  text-decoration: none;
  transition: color 0.25s ease;
  font-weight: 400;
  cursor: pointer;
}
.breadcrumb-bar ::ng-deep xng-breadcrumb .xng-breadcrumb-link:hover,
.breadcrumb-bar .add-listing-breadcrumb-root .xng-breadcrumb-link:hover {
  color: var(--brand-accent);
  text-decoration: none;
}
.breadcrumb-bar ::ng-deep xng-breadcrumb .xng-breadcrumb-trail,
.breadcrumb-bar .add-listing-breadcrumb-root .xng-breadcrumb-trail {
  color: var(--brand-accent);
  font-weight: 500;
}
.breadcrumb-bar ::ng-deep xng-breadcrumb .xng-breadcrumb-separator,
.breadcrumb-bar .add-listing-breadcrumb-root .xng-breadcrumb-separator {
  display: flex;
  align-items: center;
  -webkit-user-select: none;
          user-select: none;
  margin-left: 8px;
  margin-right: 8px;
  color: var(--brand-accent);
}
.breadcrumb-bar ::ng-deep xng-breadcrumb .xng-breadcrumb-separator mat-icon,
.breadcrumb-bar .add-listing-breadcrumb-root .xng-breadcrumb-separator mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  line-height: 18px;
}
.breadcrumb-bar ::ng-deep xng-breadcrumb .xng-breadcrumb-item:last-of-type .xng-breadcrumb-trail,
.breadcrumb-bar .add-listing-breadcrumb-root .xng-breadcrumb-item:last-of-type .xng-breadcrumb-trail {
  color: var(--brand-accent);
  font-weight: 600;
  letter-spacing: 0.5px;
}
.breadcrumb-bar :ng-deep .xng-breadcrumb-root {
  padding: 0;
  margin: 0;
}

@media (max-width: 960px) {
  .slick-header {
    height: 60px;
    padding: 0 16px;
    position: relative;
  }
  .logo-link {
    margin-right: 16px;
  }
  .logo-link .brand {
    display: none;
  }
  .search-row {
    margin: 0;
    margin-right: 60px;
    max-width: none;
  }
  .search-container {
    margin: 0;
    flex: 1;
    max-width: none;
    padding: 8px 16px;
  }
  .categories-btn span {
    display: none;
  }
  .nav-actions {
    display: none;
  }
  .breadcrumb-bar .container {
    margin-left: 0;
    padding: 0 16px;
  }
  .breadcrumb-bar .container button {
    margin-right: 12px;
    color: var(--brand-accent);
    transition: all 0.3s ease;
  }
  .breadcrumb-bar .container button:hover {
    background: var(--brand-accent-soft);
    color: var(--brand-accent-hover);
    transform: scale(1.05);
  }
  ::ng-deep .custom-col-1-5 {
    width: 12.5%;
  }
}
@media (max-width: 480px) {
  .slick-header {
    padding: 0 12px;
  }
  .search-row {
    margin-right: 50px;
  }
  .search-container {
    padding: 6px 12px;
  }
  .mobile-menu {
    right: 12px;
  }
}
::ng-deep ng2-completer .dropdown-menu,
::ng-deep ng2-completer ul,
::ng-deep .completer-dropdown,
::ng-deep .completer-dropdown-menu,
::ng-deep .dropdown-menu {
  position: fixed !important;
  left: 0 !important;
  top: 70px !important;
  width: 100vw !important;
  height: 150px !important;
  max-height: 150px !important;
  overflow-y: auto !important;
  background: white !important;
  border: 1px solid #ddd !important;
  border-radius: 0 !important;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15) !important;
  margin: 0 !important;
  z-index: 9999 !important;
  display: block !important;
}

::ng-deep ng2-completer li,
::ng-deep .completer-item,
::ng-deep .completer-row,
::ng-deep .dropdown-item {
  padding: 12px 20px !important;
  border-bottom: 1px solid #f0f0f0 !important;
  min-height: 40px !important;
  height: 40px !important;
  display: block !important;
  line-height: 40px !important;
  color: #333 !important;
  cursor: pointer !important;
  white-space: nowrap !important;
  box-sizing: border-box !important;
}
::ng-deep ng2-completer li:hover,
::ng-deep .completer-item:hover,
::ng-deep .completer-row:hover,
::ng-deep .dropdown-item:hover {
  background: #f8f8f8 !important;
}

::ng-deep .completer-selected-row {
  background: #e6f3ff !important;
}

.search-dropdown {
  position: fixed !important;
  left: 0 !important;
  top: 70px !important;
  width: 100vw !important;
  max-height: 360px !important;
  overflow-y: auto !important;
  background: #ffffff !important;
  border-bottom: 1px solid #e7eaef !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12) !important;
  z-index: 9999 !important;
  margin: 0 !important;
  padding: 20px 24px !important;
}
.search-dropdown .results-header {
  max-width: 1200px;
  margin: 0 auto 12px;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: #98a2b3;
}
.search-dropdown .results-grid {
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 4px 16px;
}
.search-dropdown .result-link {
  color: #374151;
  text-decoration: none;
  font-size: 13px;
  font-weight: 400;
  letter-spacing: 0.3px;
  transition: all 0.2s ease;
  display: block;
  padding: 8px 12px;
  border-radius: 8px;
}
.search-dropdown .result-link:hover {
  color: var(--brand-accent);
  background: var(--brand-accent-soft);
}
.search-dropdown::-webkit-scrollbar {
  width: 6px;
}
.search-dropdown::-webkit-scrollbar-track {
  background: #f1f4f8;
  border-radius: 3px;
}
.search-dropdown::-webkit-scrollbar-thumb {
  background: #cbd2dc;
  border-radius: 3px;
}
.search-dropdown::-webkit-scrollbar-thumb:hover {
  background: #b3bcc9;
}
.search-dropdown .categories-empty {
  max-width: 1200px;
  margin: 0 auto;
  padding: 8px 12px 4px;
  color: #6b7280;
  font-size: 14px;
}

::ng-deep xng-breadcrumb {
  text-transform: uppercase;
}

.profile-jumbo {
  position: relative;
  min-height: 200px;
  max-height: 280px;
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: flex-end;
  overflow: hidden;
  border-bottom: 1px solid #e7eaef;
}

.profile-jumbo__scrim {
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(10, 14, 20, 0.15) 0%, rgba(10, 14, 20, 0.65) 100%);
  pointer-events: none;
}

.profile-jumbo__inner {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 24px 20px;
}

.profile-jumbo__name {
  margin: 0;
  font-size: clamp(1.75rem, 3.5vw, 2.5rem);
  font-weight: 700;
  letter-spacing: -0.02em;
  color: #1a1a1a;
}

.profile-jumbo__name--on-image {
  color: #fff;
  text-shadow: 0 1px 16px rgba(0, 0, 0, 0.4);
}

.profile-jumbo--image .profile-jumbo__name {
  color: #fff;
  text-shadow: 0 1px 16px rgba(0, 0, 0, 0.4);
}

@media (max-width: 600px) {
  .profile-jumbo {
    min-height: 140px;
    max-height: 180px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/header/header-slick.component.scss"],"names":[],"mappings":"AAAA;EACE,0EAAA;EACA,iFAAA;EACA,gFAAA;EACA,iFAAA;EACA,gFAAA;AACF;;AAEA;EACE,YAAA;EACA,mBAAA;EACA,2DAAA;EACA,cAAA;EACA,kBAAA;AACF;;AAEA;EACE,cAAA;EACA,iBAAA;AACF;;AAEA;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,cAAA;EACA,kBAAA;EACA,yBAAA;AACF;AACE;EACE,sBAAA;AACJ;AAEE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,2DAAA;EACA,WAAA;EACA,6FAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AAAJ;AAEI;EACE,uBAAA;EACA,UAAA;AAAN;AAEM;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;AAAR;AAKE;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,6FAAA;AAHJ;;AAOA;EACE,gBAAA;EACA,cAAA;EACA,YAAA;AAJF;;AAOA;EACE,cAAA;AAJF;;AAOA;EACE,YAAA;EACA,mBAAA;EACA,qBAAA;EACA,cAAA;EACA,gBAAA;EACA,qBAAA;EACA,eAAA;EACA,mBAAA;EACA,0BAAA;AAJF;AAME;EACE,iBAAA;EACA,0BAAA;AAJJ;AAOE;EAEE,iCAAA;EACA,oCAAA;EACA,0BAAA;AANJ;;AAUA;EACE,eAAA;EACA,SAAA;EACA,cAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,iDAAA;AAPF;AASE;EACE,gBAAA;EACA,iCAAA;EACA,+EAAA;AAPJ;AAUE;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,2BAAA;AARJ;AAWE;EACE,OAAA;EACA,uBAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;AATJ;AAWI;EACE,cAAA;EACA,gBAAA;AATN;AAaE;EACE,cAAA;EACA,iBAAA;EACA,yBAAA;AAXJ;AAaI;EACE,oCAAA;EACA,0BAAA;EACA,qBAAA;AAXN;AAeE;EACE,0BAAA;AAbJ;AAgBE;EACE,2BAAA;EACA,4BAAA;AAdJ;AAgBI;EACE,0BAAA;AAdN;AAqBE;;;EAGE,uBAAA;EACA,wBAAA;EACA,4BAAA;EACA,2BAAA;EACA,4BAAA;EACA,iCAAA;EACA,2BAAA;EACA,qDAAA;EACA,yCAAA;EACA,wBAAA;EACA,yBAAA;AAnBJ;AAsBE;;;EAGE,6BAAA;EACA,2CAAA;EACA,2BAAA;EACA,uBAAA;EACA,yBAAA;EACA,4BAAA;EACA,sBAAA;EACA,0BAAA;EACA,8BAAA;AApBJ;AAsBI;;;EACE,8BAAA;AAlBN;;AAuBA;EACE,UAAA;EACA,iBAAA;AApBF;AAsBE;EACE,6DAAA;EACA,WAAA;EACA,gBAAA;EACA,gDAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,6GAAA;EACA,yBAAA;AApBJ;AAsBI;EACE,2BAAA;EACA,6GAAA;EACA,gEAAA;AApBN;AAuBI;EACE,iBAAA;AArBN;AAyBE;EACE,cAAA;EACA,aAAA;EACA,yBAAA;AAvBJ;AAyBI;EACE,oCAAA;EACA,0BAAA;EACA,qBAAA;AAvBN;AA2BE;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,QAAA;AAzBJ;AA2BI;EACE,mBAAA;EACA,2BAAA;AAzBN;AA4BI;EACE,gBAAA;EACA,qBAAA;EACA,0BAAA;AA1BN;AA6BI;EACE,+BAAA;AA3BN;AA8BI;EACE,yBAAA;AA5BN;;AAiCA;EACE,eAAA;EACA,mBAAA;EACA,0CAAA;EACA,2BAAA;EACA,0CAAA;AA9BF;AAgCE;EACE,aAAA;EACA,mBAAA;EACA,aAAA;EACA,+BAAA;EACA,YAAA;EACA,0BAAA;EACA,4BAAA;EACA,SAAA;AA9BJ;AAgCI;EACE,eAAA;AA9BN;AAiCI;EACE,gBAAA;EACA,eAAA;AA/BN;AAkCI;EACE,eAAA;EACA,YAAA;AAhCN;AAoCE;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,SAAA;AAlCJ;AAoCI;EACE,oCAAA;AAlCN;AAqCI;EACE,0BAAA;AAnCN;;AAwCA;EACE,mBAAA;EACA,gCAAA;EACA,cAAA;AArCF;AAuCE;EACE,eAAA;EACA,WAAA;EACA,SAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AArCJ;AAwCE;EACE,cAAA;EACA,0BAAA;AAtCJ;AAwCI;EACE,0BAAA;EACA,oCAAA;AAtCN;AA2CE;;EAEE,oBAAA;EACA,mBAAA;EACA,OAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,8BAAA;AAzCJ;AA4CE;EACE,iBAAA;EACA,iBAAA;AA1CJ;AA4CI;EACE,iBAAA;AA1CN;AA8CE;;EAEE,eAAA;EACA,gDAAA;EACA,gBAAA;EACA,qBAAA;EACA,cAAA;AA5CJ;AAkDI;;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;AA/CN;AAkDI;;EACE,gBAAA;AA/CN;AAkDI;;;;EAEE,aAAA;EACA,mBAAA;EACA,mBAAA;AA9CN;AAiDI;;EACE,WAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,eAAA;AA9CN;AAgDM;;EACE,0BAAA;EACA,qBAAA;AA7CR;AAiDI;;EACE,0BAAA;EACA,gBAAA;AA9CN;AAiDI;;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,0BAAA;AA9CN;AAgDM;;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AA7CR;AAiDI;;EACE,0BAAA;EACA,gBAAA;EACA,qBAAA;AA9CN;AAkDE;EACE,UAAA;EACA,SAAA;AAhDJ;;AAsDA;EACE;IACE,YAAA;IACA,eAAA;IACA,kBAAA;EAnDF;EAsDA;IACE,kBAAA;EApDF;EAsDE;IACE,aAAA;EApDJ;EAwDA;IACE,SAAA;IACA,kBAAA;IACA,eAAA;EAtDF;EAyDA;IACE,SAAA;IACA,OAAA;IACA,eAAA;IACA,iBAAA;EAvDF;EA0DA;IACE,aAAA;EAxDF;EA2DA;IACE,aAAA;EAzDF;EA4DA;IACE,cAAA;IACA,eAAA;EA1DF;EA4DE;IACE,kBAAA;IACA,0BAAA;IACA,yBAAA;EA1DJ;EA4DI;IACE,oCAAA;IACA,gCAAA;IACA,sBAAA;EA1DN;EA+DA;IACE,YAAA;EA7DF;AACF;AAgEA;EACE;IACE,eAAA;EA9DF;EAiEA;IACE,kBAAA;EA/DF;EAkEA;IACE,iBAAA;EAhEF;EAmEA;IACE,WAAA;EAjEF;AACF;AAqEA;;;;;EAKE,0BAAA;EACA,kBAAA;EACA,oBAAA;EACA,uBAAA;EACA,wBAAA;EACA,4BAAA;EACA,2BAAA;EACA,4BAAA;EACA,iCAAA;EACA,2BAAA;EACA,qDAAA;EACA,oBAAA;EACA,wBAAA;EACA,yBAAA;AAnEF;;AAsEA;;;;EAIE,6BAAA;EACA,2CAAA;EACA,2BAAA;EACA,uBAAA;EACA,yBAAA;EACA,4BAAA;EACA,sBAAA;EACA,0BAAA;EACA,8BAAA;EACA,iCAAA;AAnEF;AAqEE;;;;EACE,8BAAA;AAhEJ;;AAoEA;EACE,8BAAA;AAjEF;;AAqEA;EACE,0BAAA;EACA,kBAAA;EACA,oBAAA;EACA,uBAAA;EACA,4BAAA;EACA,2BAAA;EACA,8BAAA;EACA,2CAAA;EACA,qDAAA;EACA,wBAAA;EACA,oBAAA;EACA,6BAAA;AAlEF;AAoEE;EACE,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,cAAA;AAlEJ;AAqEE;EACE,iBAAA;EACA,cAAA;EACA,aAAA;EACA,4DAAA;EACA,aAAA;AAnEJ;AAsEE;EACE,cAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;AApEJ;AAsEI;EACE,0BAAA;EACA,oCAAA;AApEN;AAwEE;EACE,UAAA;AAtEJ;AAyEE;EACE,mBAAA;EACA,kBAAA;AAvEJ;AA0EE;EACE,mBAAA;EACA,kBAAA;AAxEJ;AA0EI;EACE,mBAAA;AAxEN;AA4EE;EACE,iBAAA;EACA,cAAA;EACA,qBAAA;EACA,cAAA;EACA,eAAA;AA1EJ;;AA+EA;EACE,yBAAA;AA5EF;;AA+EA;EACE,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,sBAAA;EACA,2BAAA;EACA,aAAA;EACA,qBAAA;EACA,gBAAA;EACA,gCAAA;AA5EF;;AA+EA;EACE,kBAAA;EACA,QAAA;EACA,2FAAA;EACA,oBAAA;AA5EF;;AA+EA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;AA5EF;;AA+EA;EACE,SAAA;EACA,wCAAA;EACA,gBAAA;EACA,uBAAA;EACA,cAAA;AA5EF;;AA+EA;EACE,WAAA;EACA,0CAAA;AA5EF;;AA+EA;EACE,WAAA;EACA,0CAAA;AA5EF;;AA+EA;EACE;IACE,iBAAA;IACA,iBAAA;EA5EF;AACF","sourcesContent":[":host {\n  /* Inherit --brand-* from :root (BrandThemeService). Soft/hover helpers. */\n  --brand-accent-hover: color-mix(in srgb, var(--brand-accent, #2563eb) 85%, black);\n  --brand-accent-soft: color-mix(in srgb, var(--brand-accent, #2563eb) 10%, white);\n  --brand-button-hover: color-mix(in srgb, var(--brand-button, #2563eb) 85%, black);\n  --brand-button-soft: color-mix(in srgb, var(--brand-button, #2563eb) 10%, white);\n}\n\n.slick-header {\n  height: 70px;\n  background: #ffffff;\n  box-shadow: 0 1px 0 #e7eaef, 0 2px 12px rgba(0,0,0,0.04);\n  color: #1a1a1a;\n  position: relative;\n}\n\n.menu-btn {\n  color: #1a1a1a;\n  margin-right: 8px;\n}\n\n.mobile-menu {\n  position: absolute;\n  right: 16px;\n  top: 50%;\n  transform: translateY(-50%);\n  z-index: 10;\n}\n\n.logo-link {\n  display: flex;\n  align-items: center;\n  text-decoration: none;\n  color: #1a1a1a;\n  margin-right: 24px;\n  transition: all 0.3s ease;\n\n  &:hover {\n    transform: scale(1.03);\n  }\n\n  .logo-mark {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 38px;\n    height: 38px;\n    border-radius: 10px;\n    background: var(--brand-icon, var(--brand-accent, #2563eb));\n    color: #fff;\n    font-family: var(--brand-font-family, 'Source Sans Pro', 'Helvetica Neue', Arial, sans-serif);\n    font-weight: 800;\n    font-size: 20px;\n    line-height: 1;\n    margin-right: 12px;\n    overflow: hidden;\n\n    &.logo-mark-image {\n      background: transparent;\n      padding: 0;\n\n      img {\n        width: 100%;\n        height: 100%;\n        object-fit: contain;\n        display: block;\n      }\n    }\n  }\n\n  .brand {\n    font-size: 16px;\n    font-weight: 500;\n    letter-spacing: 1px;\n    color: #1a1a1a;\n    font-family: var(--brand-font-family, 'Source Sans Pro', 'Helvetica Neue', Arial, sans-serif);\n  }\n}\n\n.search-row {\n  max-width: 680px;\n  margin: 0 24px;\n  min-width: 0;\n}\n\n.categories-trigger {\n  flex-shrink: 0;\n}\n\n.categories-btn {\n  height: 44px;\n  border-radius: 22px;\n  border-color: #e2e6ec;\n  color: #374151;\n  font-weight: 500;\n  letter-spacing: 0.3px;\n  padding: 0 16px;\n  background: #f8fafc;\n  transition: all 0.25s ease;\n\n  mat-icon {\n    margin-right: 6px;\n    color: var(--brand-accent);\n  }\n\n  &:hover,\n  .categories-trigger:hover & {\n    border-color: var(--brand-accent);\n    background: var(--brand-accent-soft);\n    color: var(--brand-accent);\n  }\n}\n\n.search-container {\n  max-width: none;\n  margin: 0;\n  flex: 1 1 auto;\n  min-width: 0;\n  display: flex;\n  align-items: center;\n  background: #f1f4f8;\n  border-radius: 30px;\n  padding: 10px 20px;\n  border: 1px solid #e2e6ec;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n\n  &:hover, &:focus-within {\n    background: #fff;\n    border-color: var(--brand-accent);\n    box-shadow: 0 4px 20px color-mix(in srgb, var(--brand-accent) 15%, transparent);\n  }\n\n  mat-icon:first-child {\n    color: #8a94a3;\n    margin-right: 16px;\n    font-size: 20px;\n    transition: color 0.3s ease;\n  }\n\n  ::ng-deep .search-input {\n    flex: 1;\n    background: transparent;\n    border: none;\n    outline: none;\n    color: #1a1a1a;\n    font-size: 15px;\n    font-weight: 400;\n    letter-spacing: 0.3px;\n\n    &::placeholder {\n      color: #98a2b3;\n      font-weight: 400;\n    }\n  }\n\n  button {\n    color: #6b7280;\n    margin-left: 12px;\n    transition: all 0.3s ease;\n\n    &:hover {\n      background: var(--brand-accent-soft);\n      color: var(--brand-accent);\n      transform: scale(1.1);\n    }\n  }\n\n  &:focus-within mat-icon:first-child {\n    color: var(--brand-accent);\n  }\n\n  .clear-btn {\n    margin-left: 4px !important;\n    margin-right: 4px !important;\n\n    mat-icon {\n      font-size: 18px !important;\n    }\n  }\n\n\n\n  // ng2-completer dropdown styling\n  ::ng-deep .completer-dropdown,\n  ::ng-deep .completer-dropdown-menu,\n  ::ng-deep .dropdown-menu {\n    width: 100vw !important;\n    height: 150px !important;\n    max-height: 150px !important;\n    overflow-y: auto !important;\n    background: white !important;\n    border: 1px solid #ddd !important;\n    border-radius: 0 !important;\n    box-shadow: 0 4px 20px rgba(0,0,0,0.15) !important;\n    margin-left: calc(-50vw + 50%) !important;\n    z-index: 9999 !important;\n    display: block !important;\n  }\n\n  ::ng-deep .completer-item,\n  ::ng-deep .completer-row,\n  ::ng-deep .dropdown-item {\n    padding: 12px 20px !important;\n    border-bottom: 1px solid #f0f0f0 !important;\n    min-height: 40px !important;\n    height: 40px !important;\n    display: block !important;\n    line-height: 40px !important;\n    color: #333 !important;\n    cursor: pointer !important;\n    white-space: nowrap !important;\n\n    &:hover {\n      background: #f8f8f8 !important;\n    }\n  }\n}\n\n.nav-actions {\n  z-index: 2;\n  margin-left: auto;\n\n  .sell-btn {\n    background: var(--brand-button, var(--brand-accent, #2563eb));\n    color: #fff;\n    font-weight: 500;\n    font-family: 'Helvetica Neue', Arial, sans-serif;\n    letter-spacing: 0.5px;\n    border-radius: 20px;\n    padding: 0 20px;\n    box-shadow: 0 4px 15px color-mix(in srgb, var(--brand-button, var(--brand-accent, #2563eb)) 30%, transparent);\n    transition: all 0.3s ease;\n\n    &:hover {\n      transform: translateY(-2px);\n      box-shadow: 0 6px 20px color-mix(in srgb, var(--brand-button, var(--brand-accent, #2563eb)) 40%, transparent);\n      background: var(--brand-button-hover, var(--brand-accent-hover));\n    }\n\n    mat-icon {\n      margin-right: 8px;\n    }\n  }\n\n  button[mat-icon-button] {\n    color: #4a4a4a;\n    margin: 0 4px;\n    transition: all 0.3s ease;\n\n    &:hover {\n      background: var(--brand-accent-soft);\n      color: var(--brand-accent);\n      transform: scale(1.1);\n    }\n  }\n\n  .user-btn {\n    display: flex;\n    align-items: center;\n    padding: 8px 16px;\n    border-radius: 20px;\n    background: #f1f4f8;\n    color: #1a1a1a;\n    transition: all 0.3s ease;\n    gap: 8px;\n\n    &:hover {\n      background: #e7ecf3;\n      transform: translateY(-1px);\n    }\n\n    span {\n      font-weight: 300;\n      letter-spacing: 0.5px;\n      text-transform: capitalize;\n    }\n\n    mat-icon:last-child {\n      transition: transform 0.3s ease;\n    }\n\n    &[aria-expanded=\"true\"] mat-icon:last-child {\n      transform: rotate(180deg);\n    }\n  }\n}\n\n::ng-deep .mat-menu-panel {\n  margin-top: 8px;\n  border-radius: 12px;\n  box-shadow: 0 8px 32px rgba(0,0,0,0.15);\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(255,255,255,0.1);\n\n  .user-info {\n    display: flex;\n    align-items: center;\n    padding: 16px;\n    background: var(--brand-accent);\n    color: white;\n    margin: -8px -8px 8px -8px;\n    border-radius: 12px 12px 0 0;\n    gap: 12px;\n\n    mat-icon {\n      font-size: 40px;\n    }\n\n    .name {\n      font-weight: 600;\n      font-size: 16px;\n    }\n\n    .email {\n      font-size: 12px;\n      opacity: 0.8;\n    }\n  }\n\n  button[mat-menu-item] {\n    display: flex;\n    align-items: center;\n    padding: 12px 16px;\n    transition: all 0.3s ease;\n    gap: 12px;\n\n    &:hover {\n      background: var(--brand-accent-soft);\n    }\n\n    mat-icon {\n      color: var(--brand-accent);\n    }\n  }\n}\n\n.breadcrumb-bar {\n  background: #f8fafc;\n  border-bottom: 1px solid #e7eaef;\n  padding: 4px 0;\n\n  .container {\n    max-width: none;\n    width: 100%;\n    margin: 0;\n    padding: 0 16px;\n    display: flex;\n    align-items: center;\n    gap: 2px;\n  }\n\n  button[mat-icon-button] {\n    color: #6b7280;\n    transition: all 0.25s ease;\n\n    &:hover {\n      color: var(--brand-accent);\n      background: var(--brand-accent-soft);\n    }\n  }\n\n  // Subtle divider between the home/back controls and the trail\n  xng-breadcrumb,\n  .add-listing-breadcrumb-root {\n    display: inline-flex;\n    align-items: center;\n    flex: 1;\n    min-width: 0;\n    margin-left: 6px;\n    padding-left: 12px;\n    border-left: 1px solid #e2e6ec;\n  }\n\n  .rightbar {\n    margin-left: auto;\n    text-align: right;\n\n    button {\n      margin-left: auto;\n    }\n  }\n\n  xng-breadcrumb,\n  .add-listing-breadcrumb-root {\n    font-size: 13px;\n    font-family: 'Helvetica Neue', Arial, sans-serif;\n    font-weight: 400;\n    letter-spacing: 0.4px;\n    color: #6b7280;\n  }\n\n  ::ng-deep xng-breadcrumb,\n  .add-listing-breadcrumb-root {\n\n    .xng-breadcrumb-list {\n      display: flex;\n      align-items: center;\n      flex-wrap: wrap;\n      margin: 0;\n      padding: 0;\n      list-style: none;\n    }\n\n    .xng-breadcrumb-item {\n      list-style: none;\n    }\n\n    .xng-breadcrumb-link,\n    .xng-breadcrumb-trail {\n      display: flex;\n      align-items: center;\n      white-space: nowrap;\n    }\n\n    .xng-breadcrumb-link {\n      color: #666;\n      text-decoration: none;\n      transition: color 0.25s ease;\n      font-weight: 400;\n      cursor: pointer;\n\n      &:hover {\n        color: var(--brand-accent);\n        text-decoration: none;\n      }\n    }\n\n    .xng-breadcrumb-trail {\n      color: var(--brand-accent);\n      font-weight: 500;\n    }\n\n    .xng-breadcrumb-separator {\n      display: flex;\n      align-items: center;\n      user-select: none;\n      margin-left: 8px;\n      margin-right: 8px;\n      color: var(--brand-accent);\n\n      mat-icon {\n        font-size: 18px;\n        width: 18px;\n        height: 18px;\n        line-height: 18px;\n      }\n    }\n\n    .xng-breadcrumb-item:last-of-type .xng-breadcrumb-trail {\n      color: var(--brand-accent);\n      font-weight: 600;\n      letter-spacing: 0.5px;\n    }\n  }\n\n  :ng-deep .xng-breadcrumb-root {\n    padding: 0;\n    margin: 0;\n  }\n\n}\n\n// Responsive\n@media (max-width: 960px) {\n  .slick-header {\n    height: 60px;\n    padding: 0 16px;\n    position: relative;\n  }\n\n  .logo-link {\n    margin-right: 16px;\n\n    .brand {\n      display: none;\n    }\n  }\n\n  .search-row {\n    margin: 0;\n    margin-right: 60px;\n    max-width: none;\n  }\n\n  .search-container {\n    margin: 0;\n    flex: 1;\n    max-width: none;\n    padding: 8px 16px;\n  }\n\n  .categories-btn span {\n    display: none;\n  }\n\n  .nav-actions {\n    display: none;\n  }\n\n  .breadcrumb-bar .container {\n    margin-left: 0;\n    padding: 0 16px;\n\n    button {\n      margin-right: 12px;\n      color: var(--brand-accent);\n      transition: all 0.3s ease;\n\n      &:hover {\n        background: var(--brand-accent-soft);\n        color: var(--brand-accent-hover);\n        transform: scale(1.05);\n      }\n    }\n  }\n\n  ::ng-deep .custom-col-1-5 {\n    width: 12.5%;\n  }\n}\n\n@media (max-width: 480px) {\n  .slick-header {\n    padding: 0 12px;\n  }\n\n  .search-row {\n    margin-right: 50px;\n  }\n\n  .search-container {\n    padding: 6px 12px;\n  }\n\n  .mobile-menu {\n    right: 12px;\n  }\n}\n\n// Global ng2-completer overrides - nuclear approach\n::ng-deep ng2-completer .dropdown-menu,\n::ng-deep ng2-completer ul,\n::ng-deep .completer-dropdown,\n::ng-deep .completer-dropdown-menu,\n::ng-deep .dropdown-menu {\n  position: fixed !important;\n  left: 0 !important;\n  top: 70px !important;\n  width: 100vw !important;\n  height: 150px !important;\n  max-height: 150px !important;\n  overflow-y: auto !important;\n  background: white !important;\n  border: 1px solid #ddd !important;\n  border-radius: 0 !important;\n  box-shadow: 0 4px 20px rgba(0,0,0,0.15) !important;\n  margin: 0 !important;\n  z-index: 9999 !important;\n  display: block !important;\n}\n\n::ng-deep ng2-completer li,\n::ng-deep .completer-item,\n::ng-deep .completer-row,\n::ng-deep .dropdown-item {\n  padding: 12px 20px !important;\n  border-bottom: 1px solid #f0f0f0 !important;\n  min-height: 40px !important;\n  height: 40px !important;\n  display: block !important;\n  line-height: 40px !important;\n  color: #333 !important;\n  cursor: pointer !important;\n  white-space: nowrap !important;\n  box-sizing: border-box !important;\n\n  &:hover {\n    background: #f8f8f8 !important;\n  }\n}\n\n::ng-deep .completer-selected-row {\n  background: #e6f3ff !important;\n}\n\n// Generic search results dropdown - clean, neutral, accent-themed\n.search-dropdown {\n  position: fixed !important;\n  left: 0 !important;\n  top: 70px !important;\n  width: 100vw !important;\n  max-height: 360px !important;\n  overflow-y: auto !important;\n  background: #ffffff !important;\n  border-bottom: 1px solid #e7eaef !important;\n  box-shadow: 0 8px 32px rgba(0,0,0,0.12) !important;\n  z-index: 9999 !important;\n  margin: 0 !important;\n  padding: 20px 24px !important;\n\n  .results-header {\n    max-width: 1200px;\n    margin: 0 auto 12px;\n    font-size: 12px;\n    font-weight: 600;\n    letter-spacing: 1px;\n    text-transform: uppercase;\n    color: #98a2b3;\n  }\n\n  .results-grid {\n    max-width: 1200px;\n    margin: 0 auto;\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n    gap: 4px 16px;\n  }\n\n  .result-link {\n    color: #374151;\n    text-decoration: none;\n    font-size: 13px;\n    font-weight: 400;\n    letter-spacing: 0.3px;\n    transition: all 0.2s ease;\n    display: block;\n    padding: 8px 12px;\n    border-radius: 8px;\n\n    &:hover {\n      color: var(--brand-accent);\n      background: var(--brand-accent-soft);\n    }\n  }\n\n  &::-webkit-scrollbar {\n    width: 6px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: #f1f4f8;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: #cbd2dc;\n    border-radius: 3px;\n\n    &:hover {\n      background: #b3bcc9;\n    }\n  }\n\n  .categories-empty {\n    max-width: 1200px;\n    margin: 0 auto;\n    padding: 8px 12px 4px;\n    color: #6b7280;\n    font-size: 14px;\n  }\n}\n\n\n::ng-deep xng-breadcrumb {\n  text-transform: uppercase;\n}\n\n.profile-jumbo {\n  position: relative;\n  min-height: 200px;\n  max-height: 280px;\n  background-size: cover;\n  background-position: center;\n  display: flex;\n  align-items: flex-end;\n  overflow: hidden;\n  border-bottom: 1px solid #e7eaef;\n}\n\n.profile-jumbo__scrim {\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(180deg, rgba(10, 14, 20, 0.15) 0%, rgba(10, 14, 20, 0.65) 100%);\n  pointer-events: none;\n}\n\n.profile-jumbo__inner {\n  position: relative;\n  z-index: 1;\n  width: 100%;\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 24px 20px;\n}\n\n.profile-jumbo__name {\n  margin: 0;\n  font-size: clamp(1.75rem, 3.5vw, 2.5rem);\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  color: #1a1a1a;\n}\n\n.profile-jumbo__name--on-image {\n  color: #fff;\n  text-shadow: 0 1px 16px rgba(0, 0, 0, 0.4);\n}\n\n.profile-jumbo--image .profile-jumbo__name {\n  color: #fff;\n  text-shadow: 0 1px 16px rgba(0, 0, 0, 0.4);\n}\n\n@media (max-width: 600px) {\n  .profile-jumbo {\n    min-height: 140px;\n    max-height: 180px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
